import { Link } from "react-router-dom";
import { ChevronRight, Loader2 } from "lucide-react";
import { money } from "@/lib/currency";
import { orderNo } from "@/lib/order";
import { useT } from "@/lib/i18n";

const fmt = (iso, lang) => new Date(iso).toLocaleString(lang, { day: "numeric", month: "short", hour: "2-digit", minute: "2-digit" });

export const OrderHistory = ({ orders, currency }) => {
  const { t, lang } = useT();
  const statusLabel = { pending: t("stepPending"), preparing: t("stepPreparing"), ready: t("stepReady"), delivered: t("stepDelivered"), cancelled: t("statusCancelled") };
  return (
  <div data-testid="order-history" className="bg-white rounded-2xl border border-[#E6E1DA] p-5">
    <h2 className="font-heading text-base font-bold text-[#1F1D1B] mb-3">{t("orderHistory")}</h2>
    {orders === null ? (
      <Loader2 data-testid="order-history-loading" className="h-5 w-5 animate-spin text-[#A39E96]" />
    ) : orders.length === 0 ? (
      <p data-testid="order-history-empty" className="text-sm text-[#6B6560]">{t("noOrders")}</p>
    ) : (
      <ul className="divide-y divide-[#F0EBE3]">
        {orders.map((o) => (
          <li key={o.id}>
            <Link to={`/track/${o.id}`} data-testid={`order-history-item-${o.id}`} className="flex items-center gap-3 py-3 group">
              <div className="flex-1 min-w-0">
                <p className="text-sm font-semibold text-[#1F1D1B] truncate">{o.items.map((i) => `${i.qty}× ${i.name}${i.addons?.length ? ` (+ ${i.addons.map((a) => a.name).join(", ")})` : ""}`).join(", ")}</p>
                <p className="text-xs text-[#6B6560]">{fmt(o.created_at, lang)} · #{orderNo(o)} · {t("table", { n: o.table_number })} · <span className={`capitalize ${o.status === "cancelled" ? "text-red-600 font-semibold" : ""}`}>{statusLabel[o.status] || o.status}</span></p>
                {o.status === "cancelled" && o.cancel_reason && <p className="text-xs text-red-600 truncate">{o.cancel_reason}</p>}
              </div>
              <span className="font-mono-j text-sm font-bold text-[#1F1D1B]">{money(o.total, currency)}</span>
              <ChevronRight className="h-4 w-4 text-[#A39E96] transition-transform group-hover:translate-x-0.5" />
            </Link>
          </li>
        ))}
      </ul>
    )}
  </div>
  );
};
